import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

type ContainerProps = {
  ['data-banner-height']?: number
  ['data-content-padding']?: number
}

export const StyledContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
  transition: height 200ms;
  margin-bottom: 32px;

  ${MediaQueries.mbDown} {
    padding: 16px;
    z-index: 100;
  }

  ${MediaQueries.mbUp} {
    z-index: 11;
  }

  background-color: white;
  .animation-image {
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
    margin-top: auto;
    margin-right: auto;
    margin-bottom: auto;
    margin-left: auto;
    opacity: 0;
    ${MediaQueries.mbDown} {
      bottom: 32px;
      width: 100%;
      height: auto;
    }
    ${MediaQueries.mbUp} {
      top: 0;
      bottom: 0;
      width: auto;
      height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
      transition: height 200ms;
    }
  }

  .heading {
    opacity: 0;
  }

  .description {
    margin-top: 12px;
    opacity: 0;
  }
`

export const StyledHeadingContainer = styled.div`
  position: absolute;
  max-width: 368px;

  ${MediaQueries.mbUp} {
    top: 7%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
    .heading {
      opacity: 0;
    }

    .description {
      margin-top: 16px;
      opacity: 0;
    }
  }
`

export const StyledDataContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    top: 0;
    left: 0;
  }

  ${MediaQueries.mbUp} {
    top: 41%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  }
  .country-title {
    margin-bottom: 16px;
    color: #ffca49;
    font-family: 'Inter';
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    opacity: 0;
  }

  .charts-wrapper {
    display: flex;
    ${MediaQueries.mbDown} {
      margin-bottom: 12px;
    }

    ${MediaQueries.mbUp} {
      margin-bottom: 16px;
    }
  }
`

export const StyledLegendDesktopContainer = styled.div`
  position: absolute;

  ${MediaQueries.mbUp} {
    bottom: 2%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  }
`

export const StyledMapWrapper = styled.div`
  position: relative;
  min-height: 400px;
  ${MediaQueries.mbDown} {
    margin-top: 24px;
  }
`

export const StyledPieChart = styled.div`
  ${MediaQueries.mbDown} {
    padding: 8px 12px;
  }

  ${MediaQueries.mbUp} {
    padding: 20px 18px 18px 18px;
  }
  margin-right: 12px;
  background-color: white;
  border-radius: ${theme.borderRadius};
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  text-align: center;

  .chart-container {
    position: relative;
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;

    ${MediaQueries.mbDown} {
      margin-bottom: 4px;
    }

    ${MediaQueries.mbUp} {
      margin-bottom: 8px;
    }
    .data-label {
      position: absolute;
      color: ${theme.colors.primaryBase};
      font-size: 12px;
      font-weight: bold;
      line-height: 18px;
      .value-number {
        display: inline;
      }
    }
  }

  .chart-name {
    color: ${theme.colors.primaryBase};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`

export const StyledWeightCharts = styled.div`
  ${MediaQueries.mbDown} {
    width: 220px;
    padding: 8px 0 8px 12px;
  }

  ${MediaQueries.mbUp} {
    width: 244px;
    padding: 20px 20px 12px 20px;
  }
  background-color: white;
  border-radius: ${theme.borderRadius};
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);

  .bar-container {
    display: flex;
    width: 164px;

    ${MediaQueries.mbDown} {
      height: 24px;
    }

    ${MediaQueries.mbUp} {
      height: 32px;
      margin-bottom: 8px;
    }

    align-items: center;

    .bar-label {
      ${MediaQueries.mbDown} {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      ${MediaQueries.mbUp} {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
    }
  }
`
export const StyledLabelInfoContainer = styled.div`
  ${MediaQueries.mbDown} {
    position: absolute;
    bottom: 0;
    left: 0;

    .info {
      margin-bottom: 4px;
    }
  }

  ${MediaQueries.mbUp} {
    display: flex;

    .info {
      margin-right: 32px;
    }
  }

  .info {
    color: ${theme.colors.gray500};
    font-size: 12px;
    line-height: 18px;
  }
`

export const StyledLegendContainer = styled.div`
  min-height: 20px;
  color: ${theme.colors.gray500};
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;

  ${MediaQueries.mbDown} {
    position: absolute;
    bottom: 36px;
  }

  ${MediaQueries.mbUp} {
    display: flex;
    margin-top: 12px;
  }

  .legend {
    display: flex;
    align-items: center;

    ${MediaQueries.mbUp} {
      margin-right: 40px;
    }

    ${MediaQueries.mbDown} {
      margin-bottom: 4px;
    }

    .legend-label {
      text-align: start;
    }
  }
`

export const StyledLegendBox = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: ${theme.borderRadius};
`

export const StyledPreviousMap = styled.div`
  position: absolute;
  top: 50%;
  left: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export const StyledNextMap = styled.div`
  position: absolute;
  top: 50%;
  right: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export const StyledDotsContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    bottom: 16px;
  }
  ${MediaQueries.mbUp} {
    bottom: 24px;
  }
  left: 50%;
  display: flex;
  transform: translateX(-50%);
`
export const StyledDot = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: ${theme.colors.neutral200};
  border-radius: 50%;
  cursor: pointer;
  &[data-active='true'] {
    background-color: ${theme.colors.primaryBase};
  }
`
export const StyledPaging = styled.div`
  position: absolute;
  right: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  bottom: 2%;
  color: ${theme.colors.gray500};
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
`
